export enum NdfTestType {
    SPLIT = 'SPLIT',
    SAMPLE = 'SAMPLE',
}
